import { buildProps } from '@sgui-plus/utils'

export const anchorLinkProps = buildProps({
  title: String,
  href: {
    type: String,
    default: '#'
  }
})
